const DEFAULT_BLOCKED_SIGN_IN_MESSAGE = "We couldn't continue this sign-in attempt for the requested workspace.";

export function isBlockedSignInInterception(access) {
    return access?.blocked === true && access?.competitorInterception?.intercepted === true;
}

export function buildBlockedSignInStatusState(access, overrides = {}) {
    const interception = access?.competitorInterception || {};

    return {
        intent: overrides.intent || null,
        reason: interception.reason || access?.reasonCode || "blocked_sign_in",
        supportMessage:
            interception.supportMessage ||
            access?.supportMessage ||
            overrides.supportMessage ||
            DEFAULT_BLOCKED_SIGN_IN_MESSAGE,
        requestId: interception.requestId || access?.requestId || overrides.requestId || null,
    };
}
